import type { NavSectionProps } from 'src/components/nav-section';

import { PRIVATE_PATH } from 'src/routes/paths';

import { CONFIG } from 'src/global-config';

import { SvgColor } from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`${CONFIG.assetsDir}/assets/icons/navbar/${name}.svg`} />
);

const ICONS = {
  blog: icon('ic-blog'),
};

// ----------------------------------------------------------------------

export const navData: NavSectionProps['data'] = [
  {
    subheader: '앱 관리',
    items: [
      {
        title: '대시보드',
        path: PRIVATE_PATH.dashboard.statistics.list,
        icon: ICONS.blog,
      },
      {
        title: '공지사항',
        path: PRIVATE_PATH.dashboard.notices.root,
        icon: ICONS.blog,
        children: [
          { title: '목록', path: PRIVATE_PATH.dashboard.notices.root },
          { title: '등록 하기', path: PRIVATE_PATH.dashboard.notices.new },
        ],
      },
      {
        title: '블로그',
        path: PRIVATE_PATH.dashboard.blog.root,
        icon: ICONS.blog,
        children: [
          { title: '목록', path: PRIVATE_PATH.dashboard.blog.root },
          { title: '등록 하기', path: PRIVATE_PATH.dashboard.blog.new },
        ],
      },
      {
        title: '사용방법',
        path: PRIVATE_PATH.dashboard.guide.root,
        icon: ICONS.blog,
        children: [
          { title: '목록', path: PRIVATE_PATH.dashboard.guide.root },
          { title: '등록 하기', path: PRIVATE_PATH.dashboard.guide.new },
        ],
      },
      {
        title: '이벤트',
        path: PRIVATE_PATH.dashboard.event.root,
        icon: ICONS.blog,
        children: [
          { title: '목록', path: PRIVATE_PATH.dashboard.event.root },
          { title: '등록 하기', path: PRIVATE_PATH.dashboard.event.new },
        ],
      },
      {
        title: '약관',
        path: PRIVATE_PATH.dashboard.terms.root,
        icon: ICONS.blog,
        children: [
          { title: '목록', path: PRIVATE_PATH.dashboard.terms.root },
          { title: '등록 하기', path: PRIVATE_PATH.dashboard.terms.new },
        ],
      },
      {
        title: '알림 히스토리',
        path: PRIVATE_PATH.dashboard.notiHis.root,
        icon: ICONS.blog,
        children: [
          { title: '목록', path: PRIVATE_PATH.dashboard.notiHis.root },
          { title: '등록 하기', path: PRIVATE_PATH.dashboard.notiHis.new },
        ],
      },
      {
        title: '콜드 메일',
        path: PRIVATE_PATH.dashboard.email.root,
        icon: ICONS.blog,
        children: [
          { title: '목록', path: PRIVATE_PATH.dashboard.email.list },
          { title: '메일 발송', path: PRIVATE_PATH.dashboard.email.new },
        ],
      },
    ],
  },
];
